import { create } from "zustand";
import {
  createSetupFlareVolume,
  deleteSetupFlareVolume,
  getAllHeatingValue,
  getAllSettingFlareInformation,
  getFilterSetupFlareVolume,
  getYearFlareVolume,
  searchSetupFlareVolume,
  updateSetupFlareVolume,
} from "src/services/flare.service";
import { FlareVolumeStoreProps } from "./interface/flare-volume-store.interface";
import { CreateFlareVolume, FilterSetupFlareVolume, UpdateFlareVolume } from "src/entity/flare/flare-volume.entity";

const getInitialFilter = () => ({
  sourceName: [],
  gasName: [],
  area: [],
  volumeBy: [],
  flareName: [],
  tagPi: [],
  maxFlow: [],
  hcVolume: [],
  sentOneStackOfFlare: [],
  tagPiPortionToFlare: [],
  exceptionDate: [],
  turnaroundPeriod: [],
  emergencyPeriod: [],
  inputBy: [],
});

export const flareVolumeStore = create<FlareVolumeStoreProps>((set) => ({
  loadingAll: false,
  loadingGetMaster: false,
  loadingManageFlareVolume: false,
  loadingFlareVolume: false,
  loadingGetFlareInfo: false,
  dataFlareVolume: {
    total: 0,
    data: [],
  },
  errorFlareVolume: null,
  filterFlareVolume: {
    sourceName: [],
    gasName: [],
    area: [],
    volumeBy: [],
    flareName: [],
    tagPi: [],
    maxFlow: [],
    hcVolume: [],
    sentOneStackOfFlare: [],
    tagPiPortionToFlare: [],
    exceptionDate: [],
    turnaroundPeriod: [],
    emergencyPeriod: [],
    inputBy: [],
  },
  dataFlareInfo: [],
  dataYear: [],
  dataHeatingValueAll: [],
  clearError: (type: string) => {
    set(() => ({ [`${type}`]: null }));
  },
  setError: (type: string, value: string) => {
    set(() => ({ [`${type}`]: value }));
  },
  setLoadingAll: (loading: boolean) => {
    set(() => ({ loadingAll: loading }));
  },
  getAllHeatingValue: async (year: string) => {
    try {
      const response = await getAllHeatingValue(year);

      set(() => ({ dataHeatingValueAll: response.data?.data ?? [] }));
    } catch (error) {
      console.log();
    } finally {
    }
  },
  getAllSettingFlareInformation: async () => {
    set(() => ({ loadingGetFlareInfo: true }));
    try {
      const response = await getAllSettingFlareInformation({ isActive: true });

      set(() => ({ loadingGetFlareInfo: false, dataFlareInfo: response.data?.data ?? [] }));
    } catch (error) {
      console.log();
    } finally {
      set(() => ({ loadingGetFlareInfo: false }));
    }
  },
  getYearOfFlareVolume: async (companyId: string) => {
    try {
      const currentYear = new Date().getFullYear();
      const response = await getYearFlareVolume(companyId);

      set(() => ({ dataYear: response.data?.data && response.data.data.length == 0 ? [currentYear.toString()] : response.data.data }));
    } catch (error) {
      console.log();
    }
  },
  getFilterSetupFlareVolume: async (year: string) => {
    set(() => ({ loadingGetMaster: true }));
    try {
      const res = await getFilterSetupFlareVolume({ year });
      set(() => ({
        loadingGetMaster: false,
        filterFlareVolume: res.data?.data,
      }));
    } catch (err: any) {
      set(() => ({
        loadingGetMaster: false,
        filterFlareVolume: getInitialFilter(),
      }));
    }
  },
  searchSetupFlareVolume: async (filter: FilterSetupFlareVolume) => {
    set(() => ({ loadingFlareVolume: true }));
    try {
      const res = await searchSetupFlareVolume(filter);
      set(() => ({ loadingFlareVolume: false, dataFlareVolume: res.data?.data }));
    } catch (err: any) {
      set(() => ({ loadingFlareVolume: false, error: err?.message, dataFlareVolume: { data: [], total: 0 } }));
    }
  },
  createSetupFlareVolume: async (body: CreateFlareVolume) => {
    set(() => ({ loadingManageFlareVolume: true }));
    try {
      const res = await createSetupFlareVolume(body);
      set(() => ({ loadingManageFlareVolume: false }));
      return res.data?.data;
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageFlareVolume: false, errorFlareVolume: message }));
      return message;
    }
  },
  updateSetupFlareVolume: async (body: UpdateFlareVolume) => {
    set(() => ({ loadingManageFlareVolume: true }));
    try {
      await updateSetupFlareVolume(body);
      set(() => ({ loadingManageFlareVolume: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageFlareVolume: false, errorFlareVolume: message }));
      return message;
    }
  },
  deleteSetupFlareVolume: async (id: string) => {
    set(() => ({ loadingManageFlareVolume: true }));
    try {
      const res = await deleteSetupFlareVolume(id);
      set(() => ({ loadingManageFlareVolume: false }));
    } catch (err: any) {
      set(() => ({ loadingManageFlareVolume: false, errorFlareVolume: err?.message }));
    }
  },
}));
